import "./App.css";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
  Link,
  Outlet,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getUser } from "./actions/auth";
import { Button, CircularProgress, Typography } from "@mui/material";
import Layout from "./component/Layout";
import Login from "./pages/login";
import Profile from "./pages/profile";
import { EmployeeList, EmployeeView } from "./pages/employees";
import { ProjectList, ProjectView } from "./pages/projects";
import { PurchaseList, PurchaseView } from "./pages/purchases";
import {
  AssetList,
  AssetView,
  CategoryList,
  CategoryView,
} from "./pages/asset";
import { VendorList, VendorView } from "./pages/vendors";
import AlertBox from "./component/AlertBox";
import { CustomerList, CustomerView } from "./pages/customers";
import Tickets from "./pages/ticket";
import ViewTickets from "./pages/ticket/view.tickets";
import DocData from "./pages/ticket/view.doc";
import SubCustomer from "./pages/subCustomers/list.subcustomers";
import Reports from "./pages/reports";
import Dashboard from "./pages/dashboard/index";
import OutlookCallback from "./pages/login/outlook-callback";
import SubCustomerView from "./pages/subCustomers/view.subcustomer";
import EnableMfa from "./pages/mfa/enableMfa";
import LoginMfa from "./pages/mfa/loginMfa";
import ViewPartners from "./pages/partner/partnerList/view.partner";
import PartnerList from "./pages/partner/partnerList/list.partner";
import CommisionsList from "./pages/partner/commisions/list.commissions";
import ViewCommissions from "./pages/partner/commisions/view.commissions";
import SalesList from "./pages/partner/sales/list.sales";
import ViewSales from "./pages/partner/sales/view.sales";
import ViewCustomSales from "./pages/partner/sales/view.custom.sales";
import LeadsList from "./pages/partner/leads/list.leads";
import ViewCustomLeads from "./pages/partner/leads/view.custom.leads";
import FollowupCalender from "./pages/partner/followUpCalender/followup.calender";
import TermsConditionsView from "./pages/partner/termsAndConitions/terms.conditions.view";
import DownloadUploadAgreement from "./pages/partner/termsAndConitions/download.upload.agreement";
import Home from "./pages/home/home";
import CrmLeadsList from "./pages/crmLeads/leads/list.crmleads";
import ViewCustomCrmLeads from "./pages/crmLeads/leads/view.custom.crmleads";
import ViewCloudRep from "./pages/crmLeads/cloudRep/view.cloudrep";
import ProjectActivities from "./pages/projectActivities/project.Activities";
import ProjectRecurringActivities from "./pages/projectRecurringActivities/project.Recurring.Activitites";
import ActivitiesDocuments from "./pages/activitiesDocuments/list.activities.documents";
import WorkingStatus from "./pages/hrm/working.status.list";
import WorkingStatusView from "./pages/hrm/working.status.view";
import CRMLeadsEmailsCardList from "./pages/crmLeads/leads/list.crmleads.emails";
import CRMLeadsCallsCardList from "./pages/crmLeads/leads/list.crmleads.calls";
import CRMLeadsLinkedInCardList from "./pages/crmLeads/leads/list.crmleads.linkedin";
import TrialUsers from "./pages/trialUsers/trail.user.list";
import ViewCustomTrailUser from "./pages/trialUsers/trial.user.custom.view";
import LeaveDashboardByEmpId from "./pages/hrm/teamLeaves/teams.employee.leavebyid";
import TeamLeavesManagement from "./pages/hrm/teamLeaves/team.leaves";
import ViewCustomLeavesLeads from "./pages/hrm/myLeaves/view.custom.my.leaves";
import LeaveDashboard from "./pages/hrm/myLeaves/my.leaves.dashboard";
import HolidayCalender from "./pages/holidays/holidayCalender/holiday.calender";
import ViewCustomHoliday from "./pages/holidays/holidayCalender/view.holiday.custom";
import ResignationRequestList from "./pages/hrm/resignRequest/resignation.request.list";
import ResignationRequestView from "./pages/hrm/resignRequest/resignation.request.view";
import EmployeeResignation from "./pages/resignation/employee.resignation";
import ResignationChecklist from "./pages/hrm/resignationChecklist/resignation.checklist.list";
import ResignationChecklistDetail from "./pages/hrm/resignationChecklist/resignation.checklist.view";
import AssetsChecklist from "./pages/hrm/assetsChecklists/assets.checklist.list";
import AssetsChecklistDetail from "./pages/hrm/assetsChecklists/assets.checklist.view";
import FNFProcessList from "./pages/FNFProcess/FNFprocess.list";
import FNFPopUp from "./pages/FNFProcess/FNFPop-up";

import PaySlipList from "./pages/PaySlip/payslip.list";
import PayslipForm from "./pages/PaySlip/payslip.form";
import PaySlipHeader from "./pages/PaySlip/components/payslip.header";
import PayslipEditForm from "./pages/PaySlip/Payslip.EditForm";

import FNFProcessView from "./pages/FNFProcess/FNFprocess.view";
import KraList from "./pages/hrm/appraisal/Hr_KRA_Upload/Kra.List";
import Appraisals from "./pages/hrm/appraisal/employeeAppraisal/appraisal.list";
import AppraisalDetail from "./pages/hrm/appraisal/employeeAppraisal/appraisal.view";
import MyAppraisals from "./pages/myAppraisal/MyAppraisals";
import MeetingForm from "./pages/hrm/appraisal/employeeAppraisal/meetingForm";
import TeamsCallback from "./component/TeamsCallback";
import ScheduledMeetingForm from "./pages/hrm/appraisal/employeeAppraisal/scheduledMeetingform";
import SitesManagement from "./pages/sites-management";
import SiteContacts from "./pages/sites-management/sites-contacts";
import ExpensesManagement from "./pages/expenses";
import Inventory from "./pages/inventory-list";
import Bills from "./pages/bills";


function App() {
  const user = useSelector((state) => state.user);

  return (
    <>
      <AlertBox></AlertBox>
      <Routes>
        <Route
          path="login"
          element={
            <>
              <Login />
              <AlertBox />
            </>
          }
        />

        <Route path="auth/outlook/callback" element={<OutlookCallback />} />
        <Route path="auth/teams/callback" element={<TeamsCallback />} />

        {/* <Route
        path="/admin"
        element={<RequireAdminAuth role={user.role} loggedIn={loggedIn} />}
      >
      
      </Route> */}

        <Route path="/" element={<RequireAuth />}>
          {/* <Route
          path="/"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        /> */}
          <Route
            path="/"
            element={
              <Layout>
                <Dashboard />
              </Layout>
            }
          />
          <Route
            path="profile"
            element={
              <Layout>
                <Profile />
              </Layout>
            }
          />
             <Route
            path="/sites-contacts"
            element={
              <Layout>
                <SiteContacts />
              </Layout>
            }
          />
          <Route
            path="customer"
            element={
              <Layout>
                <CustomerList />
              </Layout>
            }
          />
          <Route
            path="customer/:id"
            element={
              <Layout>
                <CustomerView />
              </Layout>
            }
          />
          <Route
            path="subcustomer"
            element={
              <Layout>
                <SubCustomer />
              </Layout>
            }
          />
          <Route
            path="subcustomer/:id"
            element={
              <Layout>
                <SubCustomerView />
              </Layout>
            }
          />
          <Route
            path="projects"
            element={
              <Layout>
                <ProjectList />
              </Layout>
            }
          />
          <Route
            path="projects/:id"
            element={
              <Layout>
                <ProjectView />
              </Layout>
            }
          />
          <Route
            path="projects/:id/activities-documents/:activityId"
            element={
              <Layout>
                <ActivitiesDocuments />
              </Layout>
            }
          />
          <Route
            path="project-Activities"
            element={
              <Layout>
                <ProjectActivities />
              </Layout>
            }
          />
          <Route
            path="project-Activities/activities-documents/:activityId"
            element={
              <Layout>
                <ActivitiesDocuments />
              </Layout>
            }
          />
          <Route
            path="project-Recurring-Activities"
            element={
              <Layout>
                <ProjectRecurringActivities />
              </Layout>
            }
          />
          <Route
            path="purchase-orders"
            element={
              <Layout>
                <PurchaseList />
              </Layout>
            }
          />
          <Route
            path="purchase-orders/:id"
            element={
              <Layout>
                <PurchaseView />
              </Layout>
            }
          />

          <Route
            path="asset"
            element={
              <Layout>
                <AssetList />
              </Layout>
            }
          />

          <Route
            path="asset/:id"
            element={
              <Layout>
                <AssetView />
              </Layout>
            }
          />

          <Route
            path="category"
            element={
              <Layout>
                <CategoryList />
              </Layout>
            }
          />

          <Route
            path="category/:id"
            element={
              <Layout>
                <CategoryView />
              </Layout>
            }
          />

          <Route
            path="vendor"
            element={
              <Layout>
                <VendorList />
              </Layout>
            }
          />
          <Route
            path="vendor/:id"
            element={
              <Layout>
                <VendorView />
              </Layout>
            }
          />

          <Route
            path="ticket"
            element={
              <Layout>
                <Tickets />
              </Layout>
            }
          />
          <Route
            path="ticket/:id"
            element={
              <Layout>
                <ViewTickets />
              </Layout>
            }
          />
          <Route
            path="employees"
            element={
              <Layout>
                <EmployeeList />
              </Layout>
            }
          />
          <Route
            path="employees/:id"
            element={
              <Layout>
                <EmployeeView />
              </Layout>
            }
          />
          <Route
            path="reports"
            element={
              <Layout>
                <Reports />
              </Layout>
            }
          />
          <Route path="docViewer" element={<DocData />} />
          <Route
            path="enable-mfa"
            element={
              <Layout>
                <EnableMfa />
              </Layout>
            }
          />

          <Route
            path="partners"
            element={
              <Layout>
                <PartnerList />
              </Layout>
            }
          />
          <Route
            path="partners/:id"
            element={
              <Layout>
                <ViewPartners />
              </Layout>
            }
          />
          <Route
            path="commissions"
            element={
              <Layout>
                <CommisionsList />
              </Layout>
            }
          />
          <Route
            path="commissions/:id"
            element={
              <Layout>
                <ViewCommissions />
              </Layout>
            }
          />
          <Route
            path="sales"
            element={
              <Layout>
                <SalesList />
              </Layout>
            }
          />
          <Route
            path="sales/:id"
            element={
              <Layout>
                <ViewCustomSales />
              </Layout>
            }
          />
          <Route
            path="leads"
            element={
              <Layout>
                <LeadsList />
              </Layout>
            }
          />
          <Route
            path="leads/:id"
            element={
              <Layout>
                <ViewCustomLeads />
              </Layout>
            }
          />
          <Route
            path="followup"
            element={
              <Layout>
                <FollowupCalender />
              </Layout>
            }
          />
          <Route
            path="termsandconditions"
            element={
              <Layout>
                <TermsConditionsView />
              </Layout>
            }
          />
          <Route
            path="downloadUploadAgreement"
            element={
              <Layout>
                <DownloadUploadAgreement />
              </Layout>
            }
          />
          <Route
            path="timesheet"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path="crmLeads"
            element={
              <Layout>
                <CrmLeadsList />
              </Layout>
            }
          />
          <Route
            path="crmLeadsEmails/:id"
            element={
              <Layout>
                <CRMLeadsEmailsCardList />
              </Layout>
            }
          />
          <Route
            path="crmLeadsCalls/:id"
            element={
              <Layout>
                <CRMLeadsCallsCardList />
              </Layout>
            }
          />
          <Route
            path="crmLeadsLinkedIn/:id"
            element={
              <Layout>
                <CRMLeadsLinkedInCardList />
              </Layout>
            }
          />
          <Route
            path="crmLeads/:id"
            element={
              <Layout>
                <ViewCustomCrmLeads />
              </Layout>
            }
          />
          <Route
            path="cloudRep/:id"
            element={
              <Layout>
                <ViewCloudRep />
              </Layout>
            }
          />
          <Route
            path="working-status"
            element={
              <Layout>
                <WorkingStatus />
              </Layout>
            }
          />
          <Route
            path="working-status/:id"
            element={
              <Layout>
                <WorkingStatusView />
              </Layout>
            }
          />
          <Route
            path="trial-users"
            element={
              <Layout>
                <TrialUsers />
              </Layout>
            }
          />
          <Route
            path="trial-users/:id"
            element={
              <Layout>
                <ViewCustomTrailUser />
              </Layout>
            }
          />
          <Route
            path="my-leaves"
            element={
              <Layout>
                <LeaveDashboard />
              </Layout>
            }
          />
          <Route
            path="my-leaves/:id"
            element={
              <Layout>
                <ViewCustomLeavesLeads />
              </Layout>
            }
          />
          <Route
            path="team-leaves"
            element={
              <Layout>
                <TeamLeavesManagement />
              </Layout>
            }
          />
          <Route
            path="team-leaves/:id"
            element={
              <Layout>
                <LeaveDashboardByEmpId />
              </Layout>
            }
          />

          <Route
            path="holidays"
            element={
              <Layout>
                <HolidayCalender />
              </Layout>
            }
          />
          <Route
            path="holidays/:id"
            element={
              <Layout>
                <ViewCustomHoliday />
              </Layout>
            }
          />
          <Route
            path="resignation-request"
            element={
              <Layout>
                <ResignationRequestList />
              </Layout>
            }
          />
          <Route
            path="resignation-request/:id"
            element={
              <Layout>
                <ResignationRequestView />
              </Layout>
            }
          />
          <Route
            path="resignation"
            element={
              <Layout>
                <EmployeeResignation />
              </Layout>
            }
          />
          {/* <Route
            path="resignation-checklist"
            element={
              <Layout>
                <ResignationChecklist />
              </Layout>
            }
          /> */}
          <Route
            path="resignation-checklist/:id/:status"
            element={
              <Layout>
                <ResignationChecklistDetail />
              </Layout>
            }
          />
          {/* <Route
            path="assets-checklist"
            element={
              <Layout>
                <AssetsChecklist />
              </Layout>
            }
          /> */}
          {/* <Route
            path="FNF-Process"
            element={
              <Layout>
                <FNFProcessList />
              </Layout>
            }
          /> */}
          <Route
            path="FNF-Process/:id/:status"
            element={
              <Layout>
                <FNFProcessView />
              </Layout>
            }
          />
          <Route
            path="FNF-popup"
            element={
              <Layout>
                <FNFPopUp />
              </Layout>
            }
          />
          <Route
            path="Payslip-list"
            element={
              <Layout>
                <PaySlipList />
              </Layout>
            }
          />
          <Route
            path="Payslip-Form"
            element={
              <Layout>
                <PayslipForm />
              </Layout>
            }
          />
          <Route
            path="Payslip-Form/:id"
            element={
              <Layout>
                <PayslipEditForm />
              </Layout>
            }
          />
          <Route
            path="appraisal"
            element={
              <Layout>
                <Appraisals />
              </Layout>
            }
          />
          <Route
            path="/appraisal/:id/:role_department"
            element={
              <Layout>
                <AppraisalDetail />
              </Layout>
            }
          />
          <Route
            path="KRA-List"
            element={
              <Layout>
                <KraList />
              </Layout>
            }
          />
          <Route
            path="my-appraisal"
            element={
              <Layout>
                <MyAppraisals />
              </Layout>
            }
          />
          <Route
            path="meeting-form/:id/"
            element={
              <Layout>
                <MeetingForm />
              </Layout>
            }
          />
             <Route
            path="scheduled-meeting-form/:id/"
            element={
              <Layout>
                <ScheduledMeetingForm />
              </Layout>
            }
          />
          <Route
            path="assets-checklist/:id/:status"
            element={
              <Layout>
                <AssetsChecklistDetail />
              </Layout>
            }
          />
             <Route
            path="site-management"
            element={
              <Layout>
                <SitesManagement />
              </Layout>
            }
          />
              {/* <Route
            path="sites-contacts"
            element={
              <Layout>
                <SiteContacts />
              </Layout>
            }
          /> */}
            <Route
            path="expenses-management"
            element={
              <Layout>
                <ExpensesManagement />
              </Layout>
            }
          />
            <Route
            path="inventory-list"
            element={
              <Layout>
                <Inventory />
              </Layout>
            }
          />
          <Route
          path="bills"
          element={
            <Layout>
              <Bills/>
            </Layout>
          }
          />
        </Route>
    
      
        
        <Route
          path="verify-mfa"
          element={
            <NoAuth>
              <LoginMfa />
            </NoAuth>
          }
        />
        <Route path="accessDenied" element={<AccessDenied />}></Route>

        <Route path="*" element={<Nothing />}></Route>
      </Routes>
    </>
  );
}

export default App;
function RequireAuth() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isLoggedIn } = useSelector((state) => state.user);
  const { role } = useSelector((state) => state.user);
  const [suspense, setSuspense] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && !isLoggedIn) {
      dispatch(getUser(token));
      setSuspense(true);
    } else if (isLoggedIn) {
      setSuspense(false);
      navigate(pathname);
    } else {
      navigate("/login", { replace: true });
    }
  }, [pathname, isLoggedIn]);
  useEffect(() => {
    if (!suspense) {
      if (pathname === "/") {
        // Check for "Partner" role or loggedIn status
        if (role === "Partner" && isLoggedIn) {
          navigate("/profile");
        }
      } else if (!isLoggedIn) {
        // Redirect to login page if not logged in
        navigate("/login", { replace: true });
      }
    }
  }, [suspense, pathname, role, isLoggedIn, navigate]);
  return suspense ? <Loading /> : <Outlet />;
}

// function RequireAuth({ loggedIn }) {
//   return loggedIn ? (
//     <>
//       <Outlet />
//       <AlertBox />
//     </>
//   ) : (
//     <Navigate to="/login" replace />
//   );
// }

// function RequireAdminAuth({ loggedIn }) {
//   if (loggedIn) {
//     return (
//       <>
//         {" "}
//         <Outlet /> <AlertBox />{" "}
//       </>
//     );
//   } else {
//     return <Navigate to="/login" replace />;
//   }
// }

function Nothing() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <Typography variant="h3" fontWeight="600">
          Nothing Here !!!
        </Typography>
        <br />
        <Link to="/">
          <Button variant="contained">Back To Home</Button>
        </Link>
      </div>
    </div>
  );
}

function AccessDenied() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <Typography variant="h3" fontWeight="600">
          Access Denied !!!
        </Typography>
        <Typography variant="h6">Only Allowed to Admins.</Typography>
        <br />
        <Link to="/">
          <Button variant="contained">Back To Home</Button>
        </Link>
      </div>
    </div>
  );
}

function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <Typography variant="h3" fontWeight="600">
          Logging In ...
        </Typography>
        <br />
        <CircularProgress />
      </div>
    </div>
  );
}
function NoAuth({ children }) {
  const token = localStorage.getItem("token");
  const { isLoggedIn } = useSelector((state) => state.user);

  return token || isLoggedIn ? <Navigate to="/" /> : children;
}
